import { useMemo } from "react";

export function usePaginatedItems<T>(items: T[], page: number, rowsPerPage: number): T[] {
  return useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;

    return items.slice(start, end);
  }, [items, page, rowsPerPage]);
}
